import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { useFlags } from 'app/flagsmith';
import { featureFlags, isFeatureEnabled } from 'app/flagsmith/features';

import { routeConfig } from './routeConfig';

export const useRouteConfig = (type?: string) => {
  const [data, setData] = useState(undefined);
  const { inventory_v3_features: inventoryV3Features } = useFlags([
    featureFlags.inventoryV3,
  ]);
  let { pathname: path = '' } = useLocation();

  if (type && type === 'navBar') {
    path = `/${path.split('/')[1]}`;
  }

  useEffect(() => {
    let config = routeConfig[path];
    if (!config) {
      config = routeConfig['/'];
    }

    const visibleConfig = config?.navBar
      ? {
          ...config,
          navBar: {
            ...config.navBar,
            list: config.navBar.list.filter(
              item =>
                item.featureFlag !== featureFlags.inventoryV3 ||
                isFeatureEnabled(inventoryV3Features),
            ),
          },
        }
      : config;

    if (type) {
      setData(visibleConfig[type]);
    } else {
      setData(visibleConfig);
    }
  }, [type, path, inventoryV3Features]);

  return data;
};
